import { theme } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import useSize from 'antd/es/config-provider/hooks/useSize';

export const useInputPaddingTokens = (customSize?: SizeType) => {
  const size = useSize((ctx) => customSize ?? ctx);
  const {
    paddingBlock = 4,
    paddingBlockLG = 7,
    paddingBlockSM = 0,
    paddingInline = 11,
    paddingInlineLG = 11,
    paddingInlineSM = 7,
  } = theme.useToken().token.Input || {};

  return size === 'small'
    ? [paddingBlockSM, paddingInlineSM]
    : size === 'large'
    ? [paddingBlockLG, paddingInlineLG]
    : [paddingBlock, paddingInline];
};
